import { type FC, useMemo } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";
import { useTagTypesAutocompleteQuery } from "@/partner/entities/tags";

interface TagsFilterProps {
  onCreateTag: () => void;
}

export const TagsFilter: FC<TagsFilterProps> = ({ onCreateTag }) => {
  const { t } = useTranslation();

  // Типы тегов у организации наперечёт (порнозвёзды, категории, жанры),
  // поэтому весь список приходит одним запросом автокомплита и рисуется
  // чипами: выбрать тип в один клик быстрее, чем раскрывать селект.
  const { data } = useTagTypesAutocompleteQuery({
    variables: { input: "", value: [] },
  });

  const quickFilters = useMemo(() => {
    const options = (data?.autocomplete?.options ?? []).flatMap((option) =>
      option?.value
        ? [{ value: String(option.value), label: option.label }]
        : []
    );

    if (!options.length) return undefined;

    return [
      {
        name: "typeId",
        label: t("tags.filter.type"),
        options,
      },
    ];
  }, [data, t]);

  return (
    <Filter
      title={t("tags.filter.title")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={onCreateTag}
        >
          {t("common.actions.add")}
        </Button>
      }
      quickFilters={quickFilters}
      fields={{
        search: true,
      }}
    />
  );
};
